// extracted by css-extract-rspack-plugin
export default {"name":"name-M6i0Dd","prefill":"prefill-tHlaAL","prefill-labels":"prefill-labels-wCmqba","prefillLabels":"prefill-labels-wCmqba"};